import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3059761a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,Faqs: require('/usr/src/app/components/product-new/faqs.vue').default,ProductCard: require('/usr/src/app/components/categories/product-card.vue').default,FooterCta: require('/usr/src/app/components/common-sections/footer-cta.vue').default})
